import { AxiosError } from 'axios';
import api from './api';
import type { ApiError } from './types';

// Description: Get the current user's language preference
// Endpoint: GET /api/language
// Request: {}
// Response: { language: string }
export const getUserLanguage = async () => {
  try {
    const response = await api.get<{ language: string }>('/language/');
    return response.data;
  } catch (error) {
    console.error('Error fetching language:', error);
    const axiosError = error as AxiosError<ApiError>;

    // Handle 502 Bad Gateway specifically
    if (axiosError.response?.status === 502) {
      throw new Error('Language service is temporarily unavailable. Please try again later.');
    }

    // Handle network errors
    if (axiosError.code === 'ECONNABORTED' || axiosError.code === 'ETIMEDOUT') {
      throw new Error('Connection to language service timed out. Please check your network connection.');
    }

    throw new Error(axiosError.response?.data?.message || 'Failed to fetch user language');
  }
};

// Description: Update the current user's language preference
// Endpoint: PATCH /api/language
// Request: { language: string }
// Response: { success: boolean, message: string }
export const updateUserLanguage = async (language: string) => {
  try {
    const response = await api.patch('/language/', { language });
    localStorage.setItem('language', language); // Store the language in localStorage
    return response.data;
  } catch (error) {
    console.error('updateUserLanguage - Error:', error);
    const axiosError = error as AxiosError<ApiError>;

    // Handle 502 Bad Gateway specifically
    if (axiosError.response?.status === 502) {
      throw new Error('Language service is temporarily unavailable. Please try again later.');
    }

    // Handle network errors
    if (axiosError.code === 'ECONNABORTED' || axiosError.code === 'ETIMEDOUT') {
      throw new Error('Connection to language service timed out. Please check your network connection.');
    }

    throw new Error(axiosError.response?.data?.message || 'Failed to update user language');
  }
};